export default "__VITE_ASSET__BFvUGyEd__"